var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('shipping-table',{staticClass:"mb-4",attrs:{"shippings":_vm.shippings,"loading":_vm.loading},on:{"reload":_vm.load}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }